let variantId = '';
var g_product_name = '';
$(function () {
  g_product_name = isMobile() ? 'M-' : '';
  if (location.pathname === '/products/sapphire-air-10-ipl-hair-removal') {
    g_product_name += 'A10 ';
  } else if (
    location.pathname === '/products/sapphire-air-3-ipl-hair-removal'
  ) {
    g_product_name += 'A3 ';
  } else if (location.pathname === '/products/ulike-x-ipl-hair-removal') {
    g_product_name += 'X ';
  }

  let disCode = ''; // 优惠券code
  // cart:refresh
  document.addEventListener('variant:changed', function (event) {
    const variant = event.detail.variant; // 假设事件传递了 variant 详细信息
    commonGtmEvent(
      `${g_product_name} Product-colour-${variant.title}`,
      '',
      'Product'
    );
    //  关闭3d模型
    $('.main-image-swiper .close-three-btn').click();
    generateHtmlForVariant(variant.id);
    //更改顶部选择的值
  });

  document.addEventListener('cart:refresh', function (event) {
    autoDiscountCode(disCode);
  });

  // 添加点击事件
  // 折扣码
  $(document).on('click', '.product-info-new .btn-copy-block', function () {
    let ths = $(this);
    let code = ths.find('.code').text();
    copyTextFallback(code);
    commonGtmEvent(`${g_product_name} Product-copy ${code}`, '', 'Product');
    disCode = code;
    // 自定应用折扣
    autoDiscountCode(code);
    ths.hide();
    ths.nextAll('.copy-success').addClass('show');
    setTimeout(function () {
      ths.nextAll('.copy-success').removeClass('show');
      ths.show();
    }, 3000);
  });

  // 置顶栏 变体选择点击
  $(document).on(
    'click',
    '.product-sticky-form .combo-box__option-item',
    function () {
      $(this).attr('aria-selected', true);
      $(this).siblings().attr('aria-selected', false);
      let name = $(this).attr('value');
      $(`.color-swatch[value="${name}"]`).find('[type="radio"]').click();
      commonGtmEvent(
        g_product_name + 'Product-Floating-colour-' + name,
        '',
        'Product'
      );
    }
  );

  // 分享
  const shareUrls = {
    facebook:
      'https://www.facebook.com/sharer/sharer.php?u={url}&quote={title}',
    twitter: 'https://twitter.com/intent/tweet?url={url}&text={title}',
    pinterest:
      'https://pinterest.com/pin/create/button/?url={url}&description={description}',
    email: 'mailto:?subject={title}&body={description}%20{url}',
  };

  // 绑定点击事件
  $(document).on('click', '.main-image-swiper .share-button', function () {
    const network = $(this).data('network');

    commonGtmEvent(g_product_name + 'Product-share-' + network, '', 'Product');
    const url = encodeURIComponent(window.location.href);
    const title = encodeURIComponent(document.title);
    const description = encodeURIComponent(
      `This is exactly what I've been waiting for—the Ulike Air 10 IPL device gives you long-lasting smooth skin in just 2 weeks. Professional hair removal results at home? Yes, please! Check it out:`
    );

    // 使用模板替换标题和描述
    let shareUrl = shareUrls[network]
      .replace('{url}', url)
      .replace('{title}', title)
      .replace('{description}', description);

    // 如果是邮件分享，直接跳转
    if (network === 'email') {
      // 获取隐藏的 a 标签，并设置 href 属性
      const hiddenLink = document.getElementById('hiddenMailtoLink');
      hiddenLink.href = shareUrl;
      // 触发 a 标签的点击事件
      hiddenLink.click();
    } else {
      // 打开分享窗口
      window.open(shareUrl, '_blank');
    }
  });

  // 移动端增加分享功能
  if (isMobile()) {
    $(document).on('click', '.main-image-swiper .box-share', function () {
      // 移动端自动调用分享功能
      if (navigator.share) {
        navigator
          .share({
            title: '',
            text: `This is exactly what I've been waiting for—the Ulike Air 10 IPL device gives you long-lasting smooth skin in just 2 weeks. Professional hair removal results at home? Yes, please! Check it out:`,
            url: location.href,
          })
          .then(() => console.log('分享成功'))
          .catch((error) => console.log('分享失败', error));
      } else {
        console.log('当前浏览器不支持 Web 分享功能');
      }
    });
  }

  // 置顶向上功能
  $(document).on('click', '.product-sticky-up', function () {
    scrollToElement();
  });

  // 滚动到顶部
  $(window).scroll(function () {
    // 如果页面向下滚动超过 200px，则显示置顶图标
    let isMobileView = isMobile();
    let targetSelector = isMobileView
      ? '.p-evaluate-carousel'
      : '.box-how-to-use';

    let targetOffset = $(targetSelector).length
      ? $(targetSelector).offset().top
      : $('#footer-new').offset().top - 400;

    if ($(this).scrollTop() > targetOffset) {
      $('.product-sticky-up').fadeIn(); // 显示图标
    } else {
      $('.product-sticky-up').fadeOut(); // 隐藏图标
    }
  });

  // 自动添加购物车
  var urlParams = new URLSearchParams(window.location.search);
  var pDiscount = urlParams.get('add-discount');
  var defDiscount = urlParams.get('discount');
  if (pDiscount) {
    setCookie('discount_code', pDiscount, 1);
    addToCart(variantId);
    setTimeout(function () {
      autoDiscountCode(pDiscount);
    }, 3000);
  } else if (defDiscount) {
    setCookie('discount_code', defDiscount, 1);
    setTimeout(function () {
      autoDiscountCode(defDiscount);
    }, 3000);
  } else {
    // 自动添加折扣
    setTimeout(function () {
      if ($('.p-box-discount-code').attr('auto-apply') == 'true') {
        let code = $('.p-box-discount-code').attr('auto-code');
        disCode = code;
        setCookie('discount_code', code, 1);
        autoDiscountCode(code);
      }
    }, 2000);
  }

  // 直接添加购物车
  $(document).on('click', '.button-buy-now ', function () {
    let pid = $(".product-form__buy-buttons [name='id']").val();
    let code = $('.p-box-discount-code').attr('auto-code');
    let giftParam = {};
    $('.button-buy-now').text('').attr('aria-busy', 'true');
    buyProduct(pid, giftParam, code);
    // AB 埋点
    window._conv_q = window._conv_q || [];
    _conv_q.push(['triggerConversion', '100476462']);
    setTimeout(function () {
      $('.button-buy-now').text('Buy Now').attr('aria-busy', 'false');
    }, 2000);
  });

  if (isMobile()) {
    $('.collapsible-header').on('click', function () {
      const $content = $(this).next('.collapsible-content');
      const $toggleBtn = $(this).find('.toggle-btn');

      // Toggle the content display
      if ($content.is(':visible')) {
        $content.slideUp(300); // 使用 slideUp 动画隐藏
        $toggleBtn.text('+');
      } else {
        $content.slideDown(300); // 使用 slideDown 动画显示
        $toggleBtn.text('−');
      }
    });
    const reviweSwiper = new Swiper('.reviwe-swiper', {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    $(document).on('click', '.product-form .see-all-btn', function () {
      scrollToElement('judgeme_product_reviews');
    });

    //  初始化信息；
    $('.product-form').on('click', '.box-hair-removal .tab', function () {
      $(this).addClass('active').siblings('.tab').removeClass('active');
      const time = $(this).attr('time');
      const timeText = $(this).attr('time_text');
      const percent = $(this).attr('percent');
      const percentText = $(this).attr('percent_text');
      let $name = $('.box-hair-removal .card').eq(0).find('.name');
      let $name2 = $('.box-hair-removal .card').eq(1).find('.name');

      $name.text(percent);
      $('.box-hair-removal .card').eq(0).find('.desc').text(percentText);
      $name2.text(time);
      $('.box-hair-removal .card').eq(1).find('.desc').text(timeText);
      if ($(this).attr('data-animated') === undefined) {
        // 检查元素是否已经动画过
        const numericEnd = parseFloat(percent.replace('%', ''));
        let minNum = (Math.random() * (60 - 50) + 50).toFixed(2);
        animatePercentage($name, Number(minNum), numericEnd, 1500);
        $(this).attr('data-animated', 'true');
      }
    });
    $('.tabs .tab.active').click();

    $('.product-form').on('click', '.review-card .read-more', function () {
      const $desc = $(this).closest('.review-card');
      $desc.find('.desc-full').toggle();
      $desc.find('.desc-short').toggle();
      $desc.find('.read-more').toggle();
    });

    function animatePercentage(element, start, end, duration) {
      const range = end - start; // 动画范围
      const increment = range / (duration / 10); // 每 10 毫秒增量
      let current = start; // 当前值

      const interval = setInterval(function () {
        current += increment;
        if ((increment > 0 && current >= end) || (increment < 0 && current <= end)) {
          current = end; // 确保不会超过目标值
          clearInterval(interval);
        }
        // 保留两位小数并更新到元素文本
        element.text(current.toFixed(2) + '%');
      }, 10); // 每 10 毫秒更新一次
    }
    
  }

  // GA 埋点
  setGaDataBuryingPoint();
});

let swiperproductNav = null;
let swiperMain = null;
function initProductImages() {
  if (swiperproductNav !== null) {
    swiperproductNav.destroy(true, true);
  }
  swiperproductNav = new Swiper('.product-media-new .swiper_nav', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    freeMode: true,
    simulateTouch: true, // 启用鼠标滑动支持
    mousewheel: true,
    // lazy: {
    //   loadPrevNext: true, // 预加载前后两张图片
    // },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      640: {
        direction: 'horizontal', // 小屏幕上水平方向滚动
      },
      1024: {
        direction: 'vertical', // 大屏幕上垂直方向滚动
      },
    },
  });
  if (swiperMain !== null) {
    swiperMain.destroy(true, true);
  }
  swiperMain = new Swiper('.product-media-new .swiper_main', {
    spaceBetween: 10,
    lazy: {
      loadPrevNext: true, // 预加载前后两张图片
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper_main .swiper-button-next',
      prevEl: '.swiper_main .swiper-button-prev',
    },
    thumbs: {
      swiper: swiperproductNav,
    },
    on: {
      slideChange: function () {
        // 在这里添加你的逻辑，例如更新其他组件状态等
        if (typeof commonGtmEvent === 'function') {
          commonGtmEvent(
            g_product_name + 'Product-indicator',
            this.activeIndex,
            'Product'
          );
        } else {
          // console.log('commonGtmEvent 方法不存在');
        }
      },
    },
  });
}

function getUrlParameter(paramName) {
  // 创建一个URLSearchParams对象，用于解析URL中的查询参数
  const params = new URLSearchParams(window.location.search);
  // 使用指定的参数名获取参数值并返回
  return params.get(paramName);
}

function generateHtmlForVariant(vid) {
  let currentVariant = !vid ? variantArr[0] : vid;
  variantId = currentVariant.vid;
  let variant = getUrlParameter('variant');
  if (variant) {
    variantId = variant;
    currentVariant = variantArr.filter((item) => item.vid == variant)[0];
  }

  const { position, max } = currentVariant;

  let _productHtml = '';
  let _productnavHtml = '';
  for (let i = position - 1; i < max; i++) {
    const ths = productMediaArr[i];
    let imageUrl = ths.src;
    let itemMainHtml = '';
    ths.alt = ths.alt ? ths.alt : 'Ulike Product Image';
    // 第一个直接加载 eager

    let isHighPriority = i == position - 1;
    let loadingAttr = isHighPriority ? 'fetchpriority="high"' : 'loading="lazy"';

    const pictureElement = `
      <picture>
          <source media="(max-width: 768px)" srcset="${convertShopifyImageUrl(imageUrl, isHighPriority ? '1200x': '800x')}">
          <img class="product__media-image" ${loadingAttr} src="${convertShopifyImageUrl(imageUrl, '1200x')}" alt="${ths.alt}" media_type="${ths.media_type}" >
      </picture>
      `;

    if (ths.media_type == 'video') {
      imageUrl = ths.preview_image.src;
      itemMainHtml = generateVideoHtml(ths.sources);
    } else {
      itemMainHtml = `
        <a data-id="${i}" data-pswp-src="${imageUrl}" rel="nofollow" data-pswp-width="${
        ths.width
      }"
        data-pswp-height="${ths.height}" alt="${ths.alt}" >
          ${pictureElement}
        </a> 
      `;
    }
    _productHtml += `
       <div class="swiper-slide">${itemMainHtml}</div>`;
    _productnavHtml += `
        <div class="swiper-slide">
            <div class="responsive-clip-path">
              <img class="product__media-image" width="68px" height="63px"  ${loadingAttr} src="${convertShopifyImageUrl(
      imageUrl,
      '80x'
    )}"  alt="${ths.alt}" media_type="${ths.media_type}"  />
            </div>
        </div>`;
  }
  setTimeout(function () {
    $('.swiper_main .swiper-wrapper').html(_productHtml);
    $('.swiper_nav .swiper-wrapper').html(_productnavHtml);
    initProductImages();
    // 3D 模型加载
    if (currentVariant.url) {
      $('.product-slider-btn-model')
        .attr('attr-model-url', currentVariant.url)
        .show();
    } else {
      $('.product-slider-btn-model')
        .attr('attr-model-url', currentVariant.url)
        .hide();
    }

    if (currentVariant.price != '' && currentVariant.page_price != '') {
      $('.p-box-price .price').html('US' + formatMoney(currentVariant.page_price));
      $('.p-box-price .original_price').html('US' + currentVariant.price);
      $('.pay-button').attr('data-pp-amount', currentVariant.page_price);
    } else if(currentVariant.price != '') {
      $('.p-box-price .price').html('US' + currentVariant.price);
      $('.p-box-price .original_price').html('');
    }

    if (currentVariant.variantTitle != '') {
      $('.product-info-new .product-meta__title').html(
        currentVariant.variantTitle
      );
    }

    // 描述
    if (currentVariant.describe != '') {
      $('.product-info-new .product-subinfo').html(currentVariant.describe);
    }

    if (currentVariant.discount_pictures != '') {
      $('.product-info-new .p-box-discount-code .abs-discount-detail').hide();
      $('.product-info-new .p-box-discount-code .bg-image img').attr(
        'srcset',
        currentVariant.discount_pictures
      );
      $('.product-info-new .p-box-discount-code .bg-image img').attr(
        'src',
        currentVariant.discount_pictures
      );
    } else {
      $('.product-info-new .p-box-discount-code .abs-discount-detail').show();
      $('.product-info-new .p-box-discount-code .bg-image img').attr(
        'srcset',
        $('.product-info-new .p-box-discount-code .bg-image').attr('old-image')
      );
      $('.product-info-new .p-box-discount-code .bg-image img').attr(
        'src',
        $('.product-info-new .p-box-discount-code .bg-image').attr('old-image')
      );
    }
  }, 10);
}

/**
 * 将给定的Shopify图片URL转换为指定尺寸
 * 该函数主要用于根据Shopify图片URL生成不同尺寸的图片URL
 * 它通过在原始文件名和文件扩展名之间插入尺寸大小来实现URL的转换
 *
 * @param {string} url - 原始Shopify图片的URL
 * @param {number} size - 想要转换的图片尺寸（以像素为单位）
 * @return {string} 转换后的图片URL
 */
function convertShopifyImageUrl(url, size) {
  if (url != undefined){
    return url.replace(/(\.[^/.]+)$/, `_${size}$1`);
  }
  return url;
}
/**
 * 根据提供的视频数据生成视频HTML代码
 *
 * 此函数首先对视频数据进行过滤和最大宽度查找，然后生成一个包含动态视频的HTML代码字符串
 * 生成的HTML代码包括一个video标签，其中包含多个source标签，每个标签指向一个视频文件
 * 如果浏览器不支持video标签，还会包含一个提示信息
 *
 * @param {Array} videoData 视频数据数组，每个元素包含视频的URL和MIME类型
 * @returns {string} 生成的视频HTML代码字符串
 */
function generateVideoHtml(videoData) {
  // 过滤和查找最大宽度的视频数据
  var filteredData = filterAndFindMaxWidth(videoData);

  // 初始化视频HTML代码字符串
  var videoHtml =
    '<video id="dynamicVideo" autoplay muted loop playsinline controls>';

  // 遍历过滤后的视频数据
  Object.values(filteredData).forEach(function (video) {
    // 为每个视频生成source标签并添加到视频HTML代码中
    videoHtml += `<source src="${video.url}" type="${video.mime_type}">`;
  });

  // 完成视频HTML代码，包括对不支持video标签的浏览器的提示
  videoHtml += 'Your browser does not support the video tag.</video>';

  // 返回生成的视频HTML代码字符串
  return videoHtml;
}

function filterAndFindMaxWidth(data) {
  var result = {};
  data.forEach(function (item) {
    if (!result[item.mime_type] || item.width > result[item.mime_type].width) {
      result[item.mime_type] = item;
    }
  });
  return result;
}

function setGaDataBuryingPoint() {
  // Product-indicator
  $('.product-info-new').on('click', '.shopify-payment-button', function () {
    commonGtmEvent(`${g_product_name} Product-checkout paypal`, '', 'Product');
  });
  $('.product-info-new').on('click', '#StickyAddToCart', function () {
    commonGtmEvent(
      `${g_product_name} Product-Floating-add to cart`,
      '',
      'Product'
    );
  });
}

/**
 * 将 cents（分）格式化为指定格式的货币字符串。
 *
 * @param {string|number} cents - 金额，以分为单位。
 * @param {string} format - 可选的格式化字符串，默认为空。
 * @returns {string} 格式化后的货币字符串。
 */
function formatMoney(cents, format = '') {
  // 如果cents是字符串，移除其中的小数点。
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  // 定义用于替换的正则表达式和格式字符串。
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;

  /**
   * 如果value2为null或不是数字，则返回defaultValue。
   *
   * @param {any} value2 - 需要检查的值。
   * @param {any} defaultValue - 默认值。
   * @returns {any} value2或defaultValue。
   */
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }

  /**
   * 格式化数字，使用指定的千位分隔符和小数分隔符。
   *
   * @param {number} number - 需要格式化的数字。
   * @param {number} precision - 小数点后的位数。
   * @param {string} thousands - 千位分隔符。
   * @param {string} decimal - 小数分隔符。
   * @returns {string} 格式化后的数字字符串。
   */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split('.'),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  let value = '';
  // 根据格式字符串中的占位符类型，选择不同的格式化方式。
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_no_decimals_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }

  // 根据格式字符串是否包含特定的标识，决定是否进行替换。
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
